import { render, staticRenderFns } from "./ContactPicker.vue?vue&type=template&id=c8d1b34a&"
import script from "./ContactPicker.vue?vue&type=script&lang=js&"
export * from "./ContactPicker.vue?vue&type=script&lang=js&"
import style0 from "./ContactPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports